import React from 'react';
import { Box, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * StandardDialogHeader — branded gradient header for all StandardDialog modals.
 *
 * Layout: [ title (left) ]  [ Zavior logo (centre) ]  [ X close button (right) ]
 *
 * Props:
 *   title   — string displayed on the left (e.g. "Create Trademark", "Edit Vendor")
 *   onClose — callback fired when the X button is clicked
 */
const StandardDialogHeader = ({ title, onClose }) => (
  <DialogTitle sx={{ p: 0 }}>
    <Box
      sx={{
        background: 'linear-gradient(135deg, rgba(29,61,252,0.85) 0%, rgba(62,151,255,0.85) 100%)',
        px: 3,
        py: 1.25,
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
      }}
    >
      {/* Left: title */}
      <Typography
        sx={{ color: '#fff', fontWeight: 700, fontSize: '22px', userSelect: 'none' }}
      >
        {title}
      </Typography>

      {/* Centre: Zavior logo */}
      <Box
        component="img"
        src="/assets/images/zaviorLogo.png"
        alt="Zavior"
        sx={{
          height: 28,
          width: 'auto',
          objectFit: 'contain',
          filter: 'brightness(0) invert(1)',
          opacity: 0.85,
          justifySelf: 'center',
          pointerEvents: 'none',
        }}
      />

      {/* Right: close button */}
      <Box sx={{ justifySelf: 'end' }}>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: '#fff',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.15)' },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  </DialogTitle>
);

export default StandardDialogHeader;
export { default as StandardDialogWizardFooter } from './StandardDialogWizardFooter';
